export default __webpack_public_path__ + "static/media/WiredMono-Regular.1e4e1754.otf";